import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import { IoMdClose } from "react-icons/io";
import jsonData from "./DreamBookJson/DreamBookJsonFile.json";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
const DreamBookPopup = (props) => {
  const { onClose } = props;
  const [gameType, setGameType] = useState('All');
  const [dataType, setDataType] = useState('All');
  const [searchValue, setSearchValue] = useState('');
  const [tableData, setTableData] = useState(jsonData);
  const device = useSelector((state) => state.CommonConfig.device_type);
  let navigate = useNavigate();
  const handleGameType = (e) => {
    const selectedGameType = e.target.value;
    setGameType(selectedGameType);
    setSearchValue('');
    if (selectedGameType === 'All') {
      setTableData(jsonData);
    } else {
      // Filter jsonData based on selected game type
      const filteredData = jsonData.filter(
        (item) => item[2].toLowerCase() === selectedGameType.toLowerCase()
      );
      setTableData(filteredData);
    }
  };

  const handleDataType = (e) => {
    setDataType(e.target.value);
    setSearchValue('');
  };

  const handleSearchValue = (e) => {
    // e.preventDefault();
    const value = e.target.value;
    let maxLength;
    // Set maxLength based on the selected gameType
    switch (gameType) {
      case '2D':
        maxLength = 2;
        break;
      case '3D':
        maxLength = 3;
        break;
      case '4D':
      case 'All':
        maxLength = 4;
        break;
      default:
        maxLength = 4;
    }
    // Restrict input to digits only for "Number" dataType, and limit length based on maxLength
    if (dataType === "Number") {
      if (new RegExp(`^\\d{0,${maxLength}}$`).test(value)) {
        setSearchValue(value);
      }
    } else if (dataType === "Keyword") {
      // For "Text" dataType, allow non-digit characters with no length restriction
      if (/^[^0-9]*$/.test(value)) {
        setSearchValue(value);
      }
    } else if (dataType === "All") {
      setSearchValue(value);
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();

    debugger
    if (searchValue === "") {
      setTableData(jsonData);
      return;
    }
    if (dataType === 'Number') {
      const filteredData = jsonData.filter(
        (item) =>
          (gameType === 'All' ||
            item[2].toLowerCase() === gameType.toLowerCase()) &&
          item[1].includes(searchValue)
      );
      setTableData(filteredData);
      // return;
    } else if (dataType === 'Keyword') {
      const filteredData = jsonData.filter(
        (item) =>
          (gameType === 'All' ||
            item[2].toLowerCase() === gameType.toLowerCase()) &&
          item[0].toLowerCase().includes(searchValue.toLowerCase())
      );
      setTableData(filteredData);
      // return ;
    } else if (dataType === "All") {
      // Combine filters for both "Number" and "Keyword"
      const filteredData = jsonData.filter(
        (item) =>
          (gameType === "All" ||
            item[2].toLowerCase() === gameType.toLowerCase()) &&
          (item[0].toLowerCase().includes(searchValue.toLowerCase()) ||
            item[1].includes(searchValue))
      );
      setTableData(filteredData);
    }

  };

  const handleClose = () => {
    navigate("/");
  }
  return (
    <>
      <div className="overlay">
        <div className="overlay_innerDiv" onClick={onClose}></div>
        <div className="dreambook_popup">
          <div className="book_heading">
            <button className="drembook_popup-close" onClick={device === "Mobile" ? handleClose : onClose}>
              <IoMdClose className="btnclose" />
            </button>
            <div className="result_txt">{props.t("dream_book")}</div>
          </div>
          <div className="book-form">
            {/* <form className="form-detail" onSubmit={handleSearch}> */}
            <form className="form-detail" onSubmit={handleSearch}>
              <div className="dropdown-flex">
                <div className="all_book_dropdown">
                  <select className="dropdown" value={gameType} onChange={handleGameType}>
                    <option value="All">{props.t("all")}</option>
                    <option value="2D">2D</option>
                    <option value="3D">3D</option>
                    <option value="4D">4D</option>
                  </select>
                </div>

                <div className="all_dream_dropdown">
                  <select className="dropdown" value={dataType} onChange={handleDataType}>
                    <option value="All">{props.t("all")}</option>
                    <option value="Keyword">{props.t("keyword")}</option>
                    <option value="Number">{props.t("number")}</option>
                  </select>
                </div>
              </div>

              <div className="form-group">
                <input type="text" placeholder={props.t("dream_searchValue")} value={searchValue} onChange={handleSearchValue} />
              </div>
              <div className="ser-btnbox">
                {/* <button type="submit" className="search-btn" >{props.t("search")}
                
                </button> */}
                <button type="button" className="search-btn" onClick={handleSearch}>{props.t("search")}
                </button>
              </div>
            </form>
          </div>

          <div className="container data-table">
            <table>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>{props.t("dream_interpretation")}</th>
                  <th>{props.t("interpretation_result")}</th>
                  <th>{props.t("type")}</th>
                </tr>
              </thead>
              <tbody>
                {tableData.length > 0 ? (
                  tableData.map((item, index) => {
                    return (
                      <tr key={index} className={index % 2 === 0 ? "even-row" : "odd-row"}
                      >
                        <td>{index + 1}</td>
                        <td>{item[0]}</td>
                        <td>{item[1]}</td>
                        <td>{item[2].toUpperCase()}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="4">No results found</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
};

export default withTranslation()(DreamBookPopup);
